module.exports = __webpack_public_path__ + "img/eraser.08bd6272.svg";